<template>
  <div class="select-field">
      <select
         :style="{fontFamily}"
         v-model="computedValue"
         v-bind="$props"
         :class="classes"
         >
         <option value="undefined" hidden>Select one</option>
         <option
            v-for="(option,index) in options"
            :style="{fontFamily}"
            :key="index"
            :value="option.value"
            >
            {{ option.title }}
         </option>
      </select>
   </div>
</template>

<script>
export default {
   props: {
      options: {
         type: Array,
         required: true,
         validator: options => options.every(option => option.title && option.value!=null),
      },
      value: {
         validator: value => (
            value==null ||
            typeof(value) === "string" ||
            typeof(value) === "number"
         ),
         required: true,
      },
      color: {
         type: String,
         default: 'light',
         validator: value => ['primary', 'success', 'info', 'danger', 'light'].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => ["large", "medium", "small"].includes(value),
      },
      fontFamily: {
         type: String,
         default: "'Nunito', Arial, 'sans-serif'"
      },
      noCarret: {
         type: Boolean,
         default: false,
      }
   },
   computed: {
      computedValue: {
         get() {
            return this.value;
         },
         set(newValue, oldValue)
         {
            if (newValue!==oldValue) this.$emit('input', newValue);
         }
      },
      classes()
      {
         return {
            [`${this.color}`]: true,
            [`${this.size}`]: true,
            'no-down-arrow': this.noCarret,
         };
      }
   }
}
</script>

<style lang="scss" scoped>
@mixin setTheme($color)
{
   $altered-color: darken($color, 10%);
   @if $color == $primary-color
   {
      $altered-color: lighten($color, 20%);
   }
   @else if $color == $light-color
   {
      $altered-color: grey;
   }
   option {
      background: $color;
      color: white;
      @if $color==$light-color
      {
         color: $font-color;
      }
   }
   &:focus {
      border: 1px solid rgba($altered-color, 0.9);
      box-shadow: inset 1px 1px 1px darken($light-color, 10%),
         0 0 8px rgba($color, 0.4);
   }
}

.select-field {
   color: $light-color;
}

select , select * {
   color: $font-color;
}
select {
   border-color: lightgrey;
   background-color: white;
   border-radius: 4px;
   color: $font-color;
   cursor: pointer;
   display: block;
   outline: none;
   width: 100%;
   transition: all 0.15s ease-in-out 0s;
   padding: 0.4em 0.8em;
   
   &.small {
      font-size: 0.8em;
   }
   &.medium {
      font-size: 0.9em;
   }
   &.large {
      font-size: 1em;
   }


   &.primary { @include setTheme($primary-color); }
   &.secondary { @include setTheme($secondary-color); }
   &.success { @include setTheme($success-color); }
   &.info { @include setTheme($info-color); }
   &.light { @include setTheme($light-color); }
   &.dark { @include setTheme($dark-color); }
   &.danger {
      border: 1px solid rgba($danger-color, 0.6);
      box-shadow: inset 0 1px 1px $light-color, 0 0 6px rgba($danger-color, 0.2);
      @include setTheme($danger-color);
   }

   &.no-down-arrow {
      /* remove down arrow in select for IE */
      &::-ms-expand {
         display: none;
      }
      /* for Firefox */
      -moz-appearance: none;
      /* for Chrome */
      -webkit-appearance: none;  
   }
}
</style>